// extracted by mini-css-extract-plugin
export default {"input":"FileInput_input__-HJ28"};